<template>

  <div class="container flex" style="margin-bottom: 30px;">
    <div>
      <left></left>
    </div>
    <div class="messageList flex1" style="margin-left: 20px;">
    	<div class="title">
    		公告
    	</div>
    	<div class="list" v-for="item,index in list">
    		<div class="flex" style="align-items: center;" @click="handleNoticeDetail(item.noticesId)">
    			<span class="flex1 name" style="cursor: pointer;">{{item.noticesTitle}}

          </span>


    		</div>
    	</div>

    </div>
  </div>

</template>

<script>
  import left from './accountleft.vue'
  export default {
    name: 'Footer',
    components:{
      left
    },
    data () {
      return {
          showLogin:false,
          token:window.sessionStorage.token,
          list:[]
      }
    },
    methods:{

      getData(){

            this.$axios.defaults.headers.common["Authorization"] = this.token;
        this.$axios.get(this.$common.notcice_url).then((res)=>{
              if(res.data.code==1){
                  this.list=res.data.data;
              }
              else {
                alert(res.data.msg)
              }
        })
      },
      handleNoticeDetail(id){
        this.$router.push({path:'notice?id='+id})
      }

    },
    created() {
      this.getData();
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/noticelist.vue